module.exports = __webpack_public_path__ + "img/caidan.86cbf0b3.png";